import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const WelcomeModal = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          padding: "16px",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "16px 24px",
          fontFamily: "Merriweather, serif",
          fontWeight: 700,
          fontSize: "24px",
        }}
      >
        <Box sx={{ fontSize: "32px", marginRight: "16px" }}>👋</Box>
        Hello There!
        <IconButton
          onClick={onClose}
          sx={{ marginLeft: "auto" }}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: "8px 24px 24px" }}>
        <Typography
          sx={{
            marginBottom: "24px",
            fontFamily: "Poppins, sans-serif",
            fontSize: "16px",
            lineHeight: 1.5,
          }}
        >
          Welcome to CoachCAROL, your AI powered career coach. To understand you
          a little better, please answer this 3 mins quiz. So that we can
          analyse your career wellness and unlock tailored insights for you.
          Are You Ready?
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            variant="contained"
            onClick={onClose}
            sx={{
              bgcolor: "#DF7468",
              color: "#FFFFFF",
              borderRadius: "5px",
              px: "24px",
              py: "12px",
              fontFamily: "Poppins, sans-serif",
              fontWeight: 500,
              fontSize: "16px",
              textTransform: "none",
              "&:hover": {
                bgcolor: "#DF7468",
                opacity: 0.9,
              },
            }}
          >
            Got It!
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default WelcomeModal;
